import { SET_ASSIGNED_RATERS } from "./action";

const initialState = {
  assignedRaters: [],
};

const EditPosition = (state = initialState, action) => {
  switch (action.type) {
    case SET_ASSIGNED_RATERS:
      return {
        ...state,
        assignedRaters: action.value,
      };

    default:
      return state;
  }
};

export default EditPosition;
